
const Recibo = (props) => {
    const fecha = props.recibo.cuando.split('T')[0]
    
    return (<>  
        <div className='flex flex-col text-sm px-2 my-2'>
            {props.recibo.recibo_deta.map((e, index) => {
                return (
                    <div 
                        key={`${props.recibo.id}-${index}`} 
                        className='grid grid-cols-4 text-sm px-4 items-center w-full'
                    >
                        <label className='flex justify-center'>
                            {index === 0 ? fecha : ''}
                        </label>
                        <label>{e.concepto === 'socio' ? e.categoria : e.actividad}</label> 
                        <label className='flex justify-center'>{e.cuota}</label> 
                        <label className='flex justify-end'>{e.importe}</label> 
                    </div>
                )
            })}
        </div>       
    </>)
}

export default Recibo;